import { render, staticRenderFns } from "./BasicDetailsForm.vue?vue&type=template&id=52d97756&"
import script from "./BasicDetailsForm.vue?vue&type=script&lang=js&"
export * from "./BasicDetailsForm.vue?vue&type=script&lang=js&"
import style0 from "./BasicDetailsForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports